import { render } from "./AdminCountryEdit.vue?vue&type=template&id=7cc47061&scoped=true&ts=true&lang=true"
import script from "./AdminCountryEdit.vue?vue&type=script&lang=ts"
export * from "./AdminCountryEdit.vue?vue&type=script&lang=ts"

import "./AdminCountryEdit.vue?vue&type=style&index=0&id=7cc47061&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc47061"]])

export default __exports__